import Modal from "react-modal";
import { useSortContext } from "../../contexts/SortProvider";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage } from "react-intl";
import "./SortDrawer.scss";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import IconClose from "app/pages/.shared/IconClose";
import { TripAdvisor } from "app/icons/brands";
import { SORT_OPTIONS } from "../../constants/sortOptions";
import { RadioIcon } from "app/icons/controls";
import PropTypes from "prop-types";

export const SortDrawer = ({ onChange }) => {
	const { isOpen, closeDrawer, sortBy, setSortBy, options } = useSortContext();

	const handleSortChange = optionId => {
		setSortBy(optionId);

		if (onChange) {
			onChange(optionId);
		}

		closeDrawer();
	};

	return (
		<Modal
			isOpen={isOpen}
			closeTimeoutMS={200}
			onRequestClose={closeDrawer}
			overlayClassName="sort-drawer__overlay"
			className="sort-drawer__content"
		>
			<header className="sort-drawer__header">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL}
					component="h2"
					isBold
					className="sort-drawer__radio-label-text"
				>
					<FormattedMessage id="sort.sort.by" />
				</Typography>

				<Button
					variant={BUTTON_VARIANTS.BORDERLESS}
					onClick={closeDrawer}
					className="sort-drawer__close-button"
				>
					<IconClose width="24" />
				</Button>
			</header>

			<fieldset>
				<legend className="sr-only">
					<FormattedMessage id="sort.sort.options.screen.reader" />
				</legend>

				<ul className="sort-drawer__options">
					{Object.values(options).map(option => {
						const isChecked = sortBy === option.id;

						return (
							<li key={option.id} className="sort-drawer__option">
								<input
									type="radio"
									id={option.id}
									name="sortBy"
									checked={sortBy === option.id}
									onChange={() => handleSortChange(option.id)}
									className="sort-drawer__radio-input sr-only"
								/>

								<label htmlFor={option.id} className="sort-drawer__radio-label">
									<span className="sort-drawer__radio-icon" aria-hidden="true">
										<RadioIcon checked={isChecked} />
									</span>

									<Typography
										variant={TYPOGRAPHY_VARIANTS.REGULAR}
										component="span"
										className="sort-drawer__radio-label-text"
									>
										<FormattedMessage id={option.labelKey} />
									</Typography>

									{option.id === SORT_OPTIONS.RATING_DESC.id && <TripAdvisor />}
								</label>
							</li>
						);
					})}
				</ul>
			</fieldset>
		</Modal>
	);
};

SortDrawer.propTypes = {
	onChange: PropTypes.func,
};
